import { Button, Typography } from '@arionbanki/arionui';
import { DetailsCard, Footer, Markdown, Modal } from 'components';
import { EntityProcessInfo } from 'types';
import { FLOW_TYPE } from 'consts';
import { getMode } from 'helpers';
import { useOnboard } from './useOnboard';

export function Onboard() {
	const { flowType, kennitala, person, prefix, t, ...props } = useOnboard();
	return (
		<>
			<Typography TagName="h3" className="mb-5">
				{t(`${prefix}_title`, 'userboard')}
			</Typography>
			{props.unfinishedMifid && (
				<Markdown className="arionui" href={props.mifidURL}>
					{t('UNFINISHED_MIFID', 'userboard')}
				</Markdown>
			)}
			{props.companyTranslationKey && (
				<Typography TagName="p">{t(props.companyTranslationKey, 'userboard')}</Typography>
			)}
			<Typography TagName="p" className="mb-5">
				{t(`${prefix}_description`, 'userboard')}
			</Typography>
			{FLOW_TYPE.ES_MV === flowType ? (
				<>
					<Typography TagName="p" className="bold">
						{t('children', 'userboard')}
					</Typography>
					{props.children.map((info: EntityProcessInfo) => (
						<DetailsCard
							checked={kennitala === info.kennitala}
							info={info}
							key={info.kennitala}
							onClick={props.onSelect}
						/>
					))}
				</>
			) : (
				<>
					{person.kennitala && (
						<>
							<Typography TagName="p" className="bold">
								{t('individual', 'userboard')}
							</Typography>
							<DetailsCard checked={kennitala === person.kennitala} info={person} onClick={props.onSelect} />
						</>
					)}
					<Typography TagName="p" className="bold mt-5">
						{t('company', 'userboard')}
					</Typography>
					{props.companies.map((info: EntityProcessInfo) => (
						<DetailsCard
							checked={kennitala === info.kennitala}
							info={info}
							key={info.kennitala}
							onClick={props.onSelect}
						/>
					))}
				</>
			)}
			<Footer handleNext={props.onSubmit} isDisabled={!kennitala} next={t('continue')} />
			<Modal
				background="dim"
				className={`col-11 col-md-8 col-lg-6 p-5 theme--${getMode(flowType)}`}
				handleClose={props.redirectToMifid}
				isOpen={props.isModalOpen}
			>
				<button className="close-label bold" onClick={props.redirectToMifid}>
					{t('close_window', 'userboard')}
				</button>
				<Typography TagName="p" className="my-5">
					{t('mifid_required', 'userboard')}
				</Typography>
				<Button onClick={props.redirectToMifid} width="100%">
					{t('OK')}
				</Button>
			</Modal>
		</>
	);
}
